import
{
    RifleAim,
    CharacterStateBase,
    EndWalk, Sprint, JumpRunning,
} from './_stateLibrary';
import { Character } from '../Character';
import { CharacterAnimation } from '../../enums/CharacterAnimation';
import { RifleIdle } from "./RifleIdle";
import { RifleRun } from "./RifleRun";
import { WalkAudio } from './audio/WalkAudio';

export class RifleWalk extends CharacterStateBase
{
    private audio: WalkAudio | null = null;

    constructor(character: Character)
    {
        super(character);
        this.canEnterVehicles = true;
        this.character.simulation.setArcadeVelocityTarget(0.5);
        this.playAnimation(CharacterAnimation.RifleWalk, 0.1);

        if (character.world?.audioManager) {
            this.audio = new WalkAudio(character.world.audioManager, character);
            this.audio.play();
        }
    }

    public exit(): void {
        this.audio?.stop();
    }

    public update(timeStep: number): void
    {
        super.update(timeStep);
        this.character.setCameraRelativeOrientationTarget();

        this.fallInAir();
        this.onDie();
    }

    public onInputChange(): void
    {
        super.onInputChange();

        if (this.character.actions.aim.justPressed) {
            this.character.setState(new RifleAim(this.character));
        }
        if (this.character.actions.jump.justPressed) {
            this.character.setState(new JumpRunning(this.character));
        }

        if (this.noDirection())
        {
            this.character.setState(new EndWalk(this.character));
        }


        if (this.character.actions.run.justPressed)
        {
            this.character.setState(new Sprint(this.character));
        }

/*        if (this.character.actions.jump.justPressed)
        {
            this.character.setState(new JumpRunning(this.character));
        }*/

        if (this.noDirection())
        {
            if (this.character.simulation.velocity.length() > 1)
            {
                this.character.setState(new EndWalk(this.character));
            }
            else
            {
                this.character.setState(new RifleIdle(this.character));
            }
        }
    }
}
